import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderManagementComponent } from './order-management/order-management.component';
import { CoreModule } from '../core/core.module';
import { MbscModule } from '@mobiscroll/angular';
import { NgbDropdownModule, NgbModalModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { OrderDetailComponent } from './order-detail/order-detail.component';



@NgModule({
  declarations: [
    OrderManagementComponent,
    OrderDetailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    MbscModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbModalModule,
  ]
})
export class OrdersModule { }
